export default (value, defaultValue) =>
  value || defaultValue
